<template>
<div class="v-icon">

  <div class="v-icon__image"
    v-if="local && urlIcon">
  </div>

  <i class="v-icon__icon"
    v-else-if="!local"
    :class="{ 'material-symbols-outlined': outlined, 'material-symbols': !outlined, tooltip }"
    :tooltip="tooltip"
    :style="style">
    <slot>
      {{ icon }}
    </slot>
  </i>
  
</div>
</template>

<script>
export default {
  props: {
    outlined: { type: Boolean, default: false },
    local: { type: Boolean, default: false },
    icon: { type: [String, Boolean], default: false },
    size: { type: String, default: '1em' },
    color: { type: String, default: 'inherit' },
    weight: { type: String, default: 'normal' },
    tooltip: { type: String, default: undefined },
    style: { type: [String, Object], default: undefined },
  },
  computed: {
    urlIcon() {
      const svg = document.querySelector(`#${this.icon}`)
      const svgString = svg?.outerHTML
      if (!svgString) return
      return `url("data:image/svg+xml;charset=utf-8,${this.encodeSvg(svgString)}")`
    }
  },
  methods: {
    encodeSvg(svgString) {
      return svgString.replace('<svg', (~svgString.indexOf('xmlns') ? '<svg' : '<svg xmlns="http://www.w3.org/2000/svg"') + (this.outlined ? ' stroke="#fff" stroke-width="2" fill-opacity="0"' : ''))
        .replace(/"/g, '\'')
        .replace(/%/g, '%25')
        .replace(/#/g, '%23')       
        .replace(/{/g, '%7B')
        .replace(/}/g, '%7D')         
        .replace(/</g, '%3C')
        .replace(/>/g, '%3E')
        .replace(/\s+/g,' ') 
        //  .replace(/&/g, '%26')
        //  .replace('|', '%7C')
        //  .replace('[', '%5B')
        //  .replace(']', '%5D')
        //  .replace('^', '%5E')
        //  .replace('`', '%60')
        //  .replace(';', '%3B')
        //  .replace('?', '%3F')
        //  .replace(':', '%3A')
        //  .replace('@', '%40')
        //  .replace('=', '%3D')
    }
  }
}
</script>

<style lang="scss" scoped>
.v-icon {
  display: inline-block;
  vertical-align: text-bottom;
  &__image {
    min-width: v-bind(size);
    min-height: v-bind(size);
    -webkit-mask-image: v-bind(urlIcon);
    mask-image: v-bind(urlIcon);
    mask-repeat: no-repeat;
    -webkit-mask-size: contain;
    mask-size: contain;
    mask-position: center;
    background-color: v-bind(color);
  }
  &__icon {
    display: block;
    font-size: v-bind(size);
    font-weight: v-bind(weight);
    color: v-bind(color);
    text-decoration: none !important;
  }
}
</style>